import React, { useContext } from "react";

import {
  Box,
  Flex,
  List,
  NoSSR,
  NotificationBadge,
} from "@catchoftheday/cg-components";

import { ACCOUNT_MENU_ICON_MAP } from "../consts";
import { MenuContentPopup } from "../MenuContentPopup";
import { MenuHeader } from "../MenuHeader";
import { MenuItem } from "../MenuItem";
import { MobileMenuContext } from "../MobileMenuContext";

type AccountMenuProps = {
  isOpen: boolean;
};

export const AccountMenu = ({ isOpen }: AccountMenuProps) => {
  const { accountMenu, isLoggedIn } = useContext(MobileMenuContext);

  if (!accountMenu) {
    return null;
  }

  return (
    <MenuContentPopup aria-label="Account menu" isOpen={isOpen} cover>
      <MenuHeader title="Account" bg="secondary" color="white" />
      <Box as="nav" overflowY="scroll" maxHeight="100%">
        <List pt="16px" mb="0px">
          {(isLoggedIn
            ? accountMenu.loggedInMenu
            : accountMenu.loggedOutMenu
          ).map((menuItem, index) => {
            const IconSet = ACCOUNT_MENU_ICON_MAP.find(
              (item) => item.name === menuItem.name
            );
            const isHelpCentre = menuItem.name === "Help Centre";
            const isLogout = menuItem.name === "Logout";
            return (
              <MenuItem
                key={`${menuItem.name}-${index}`}
                url={menuItem.url}
                highlight={isHelpCentre || isLogout}
                fontWeight="medium"
                borderTop={isLogout ? "0px" : undefined}
              >
                {IconSet && IconSet?.icon && (
                  <Flex width="18px" mr="10px" justifyContent="center">
                    {menuItem.name === "Flybuys" &&
                      accountMenu.flybuysNotificationCount > 0 && (
                        <NoSSR>
                          <NotificationBadge
                            aria-label="Flybuys count"
                            text=""
                            top="13px"
                            left="10px"
                            height="10px"
                            width="10px"
                            minWidth="0"
                          />
                        </NoSSR>
                      )}
                    {menuItem.name === "Messages" &&
                      accountMenu.unreadMarketplaceMessageCount > 0 && (
                        <NoSSR>
                          <NotificationBadge
                            aria-label="Marketplace messages count"
                            text={accountMenu.unreadMarketplaceMessageCount}
                            top="10px"
                            left="10px"
                            lineHeight="14px"
                            width="14px"
                            minWidth="0"
                            fontSize="2xs"
                          />
                        </NoSSR>
                      )}
                    <IconSet.icon
                      width={IconSet.shrink ? "14px" : "18px"}
                      height={IconSet.shrink ? "14px" : "18px"}
                      title={menuItem.name}
                    />
                  </Flex>
                )}
                {menuItem.name}
              </MenuItem>
            );
          })}
        </List>
      </Box>
    </MenuContentPopup>
  );
};
